import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async getDataSync(context, types) {
      return await http.get(`/data/sync` + `?types=${types.join('&types=')}`)
    },
    async startDataSync(context, types) {
      return await http.put(`/data/sync` + `?types=${types.join('&types=')}`)
    },
  },
}
